<template>
  <div class ="tpa-templates">
    <v-row justify="center" align="center">
      <v-container>
          <div class="text-h3 primary--text text-center">Templates</div>
      </v-container>
    </v-row>
    <v-card class="custom-card" outlined>
        <br>
        <v-row no-gutters class="custom-row">
            <v-col class="custom-group col-sm-12 col-md-3 mr-auto">
                <v-row no-gutters>
                    <v-col cols="auto" class="label">
                        <span>Duration</span>
                    </v-col>
                    <v-col class="pr-5">
                        <v-autocomplete
                            v-model="duration"
                            item-text="duration"
                            item-value="duration"
                            :items="globalContext.listsContext.durations"
                            return-object
                            dense outlined hide-details="true"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="custom-group col-sm-12 col-md-4 mr-auto">
                <v-row no-gutters>
                    <v-col cols="auto" class="label">
                        <span>Default Proposal</span>
                    </v-col>
                    <v-col class="pr-5">
                        <v-autocomplete
                            :value="defaultProposal"
                            item-text="template_name"
                            :items="defaultProposalTemplates"
                            return-object
                            @change="updateDefault($event)"
                            dense outlined hide-details="true"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="custom-group col-sm-12 col-md-4 mr-auto">
                <v-row no-gutters>
                    <v-col cols="auto" class="label">
                        <span>Default Agreement</span>
                    </v-col>
                    <v-col class="pr-5">
                        <v-autocomplete
                            :value="defaultAgreement"
                            item-text="template_name"
                            :items="defaultAgreementTemplates"
                            return-object
                            @change="updateDefault($event)"
                            dense outlined hide-details="true"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
            </v-col>
            <v-col class="custom-group col-sm-12 col-md-1 mr-auto">
                <v-dialog v-model="dialog" persistent max-width="600px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab dark small color="primary" v-bind="attrs" v-on="on">
                            <v-icon dark>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                        Upload
                    </template>
                    <v-card>
                        <v-toolbar color="primary custom-toolbar" dark>
                            <span>Upload Form</span>
                            <v-icon color="red" @click="closeDialog">mdi-close icon</v-icon>
                        </v-toolbar>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-card-text style="padding-bottom:0px">
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-model="template_name"
                                                label="Template Name"
                                                :rules="template_name_rules"
                                                required
                                                outlined dense hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="template_type"
                                                item-text="template_type"
                                                :items="defaultTemplateTypeAll"
                                                label="Template Type"
                                                :rules="template_type_rules"
                                                required
                                                outlined dense hide-details="auto">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="durationUpload"
                                                :items="globalContext.listsContext.durations"
                                                label="Template Duration"
                                                :rules="template_duration_rules"
                                                required
                                                outlined dense hide-details="auto">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-file-input
                                                v-model="file"
                                                :rules="template_file_rules"
                                                required
                                                label="File input"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-paperclip"
                                                outlined dense hide-details="auto">
                                            </v-file-input>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" dark @click="submitUpload()">Upload</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
        <v-row no-gutters>
                <v-col class="custom-group col-sm-12 col-md-3 mr-auto">
                    <v-row no-gutters>
                        <v-col cols="auto" class="label mr-2">
                            <span>Default Duration</span>
                        </v-col>
                        <v-col class="pr-5">
                            <v-autocomplete
                                v-model="planOpportunityDefaultSelection.duration"
                                item-text="duration"
                                item-value="duration"
                                :items="globalContext.listsContext.durations"
                                return-object
                                dense outlined hide-details="true"
                                @change="handleupdatePlanOpportunityDefaultSelection()"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        <br>
        <v-row no-gutters class="custom-row">
            <div class="template-tabs-wrapper">
                <div class="template-tab active" ref="company" @click="loadTemplateList('company')">
                    <span>Company Template</span>
                </div>
                <div class="template-tab" ref="starter" @click="loadTemplateList('starter')">
                    <span>Starter Template</span>
                </div>
            </div>
            <div class="template-content-wrapper">
                <div class="template-content-header">
                    <div class="header-col"><span>Name</span></div>
                    <div class="header-col">
                        <span style="padding-right:5px;">Type</span>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" fab x-small dark v-bind="attrs" v-on="on">
                                    <v-icon dark small>mdi-filter-menu-outline</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item link @click="loadTemplateList(current_tab, undefined, undefined)">
                                    <v-list-item-title>Clear Filter</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-for="(item, index) in template_filter" :key="index" link @click="loadTemplateList(current_tab, 'type', item)">
                                    <v-list-item-title>{{ item.template_type }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    <div class="header-col">
                        <span style="padding-right:5px;">Duration</span>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" fab x-small dark v-bind="attrs" v-on="on">
                                    <v-icon dark small>mdi-filter-menu-outline</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item link @click="loadTemplateList(current_tab, undefined, undefined)">
                                    <v-list-item-title>Clear Filter</v-list-item-title>
                                </v-list-item>
                                <v-list-item v-for="(item, index) in globalContext.listsContext.durations" :key="index" link  @click="loadTemplateList(current_tab, 'duration', item)">
                                    <v-list-item-title>{{ item }}-year</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </div>
                <div class="template-content-component">
                    <div class="template-content-row" v-for="(row, index) in templateListData" :key="row.template_id">
                        <div class="row-content-col"><span>{{ row.template_name }}</span></div>
                        <div class="row-content-col"><span>{{ row.template_type }}</span></div>
                        <div class="row-content-col"><span>{{ row.duration }}-year</span></div>
                        <div class="row-content-col">
                        <!--
                             <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-btn small class="primary" v-on="on">
                                  <span class="btn-name">Preview</span>
                                    <v-icon dark small color="green">
                                        mdi-open-in-new
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span><v-icon color="amber darken-2">mdi-alert-circle-outline</v-icon> Coming Soon!</span>
                            </v-tooltip>
                        -->
                        </div>
                        <div class="row-content-col">
                            <v-btn class="mx-2" small color="primary" @click="download(row)">
                                <span class="btn-name">Download</span>
                                <v-icon dark small>
                                    mdi-download
                                </v-icon>
                            </v-btn>
                        </div>
                        <div class="row-content-col">                            
                             <v-dialog
                                v-model="deleteDialog[index]"
                                persistent
                                :retain-focus="false"
                                 max-width="290"
                            >
                                 <template v-slot:activator="{on, row}">
                                     <v-btn class='mx-2' small color="primary"  @click="$set(deleteDialog, index, true)">
                                        <span class="btn-name">Delete</span>
                                        <v-icon
                                            dark
                                            v-on="on"
                                            v-bind="row"
                                            small
                                            color="red"
                                            
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </v-btn>
                                 </template>
                            <v-card>
                                <v-card-title class="headline">
                                  Delete Template
                                </v-card-title>
                                <v-card-text>Are you sure that you want to delete template: <span class="font-weight-bold">{{row.template_name}}?</span></v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      dark
                                      @click.native="deleteTmp(row, index)"
                                    >Delete</v-btn>
                                    <v-btn
                                        depressed
                                        @click="$set(deleteDialog, index, false)"
                                    >Cancel</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        </div>
                       
                    </div>
                    
                </div>
            </div>
        </v-row>
        <br>
    </v-card>
  </div>
</template>

<script>

    import {mapActions, mapGetters} from 'vuex';
    import {getTPAID} from  '@/store/global_helpers/sessionReturn.js';

    export default {
        data: () => ({
            dialog: false,
            loading:true,
            deleteDialog: {},
            current_tab: 'company',
            templateListData: '',
            template_filter: [
                {
                    id: 0,
                    template_type: 'proposal'
                    
                },
                {
                    id: 1,
                    template_type: 'agreement'
                }
                ],
            // dialog form
            valid: true,
            template_name: null,
            template_type: null,
            duration: "5",
            durationUpload: "5",
            templateListCopy: [],
            file: null,
            template_name_rules: [v => !!v || 'Name is required',],
            template_type_rules: [v => !!v || 'Template is required',],
            template_duration_rules: [v => !!v || 'Duration is required',],
            template_file_rules: [v => !!v || 'File is required',],
        }),

        mounted() {
            this.loadTemplateList('company');
        },

        created(){
            this.getPlanOpportunityDefaultSelection()
        },

        computed: {

            ...mapGetters({ 
                globalContext: 'globalContext',
                planOpportunityDefaultSelection: 'getplanOpportunityDefaultSelection',
            }),

            defaultProposalTemplates() {            
                let proposals = [];
                if(this.globalContext.listsContext !== null && this.globalContext.listsContext !== undefined){
                    let tmpList = this.globalContext.listsContext.proposalTemplates[this.duration].defined.concat(this.globalContext.listsContext.proposalTemplates[this.duration].starter)
                    console.log(tmpList)
                    tmpList.forEach(element => {
                        if (element.template_type === 'proposal') {
                            proposals.push(element);
                        }
                        });
                }
                return [...new Set(proposals)];
            },

            defaultProposal() {
                if(this.globalContext.templatesContext !== null && this.globalContext.templatesContext !== undefined){
                    let templates = this.globalContext.templatesContext
                    let duration = this.duration 
                    
                    let defaultObj = templates.filter(function(template){
                        return template.property.duration == duration;
                    });
                    
                    return defaultObj[0].proposal.default;
                }
                return {}
            },

            defaultAgreementTemplates() {
                let agreements = [];
                if(this.globalContext.listsContext !== null && this.globalContext.listsContext !== undefined){
                    let tmpList = this.globalContext.listsContext.agreementTemplates[this.duration].defined.concat(this.globalContext.listsContext.agreementTemplates[this.duration].starter)
                    tmpList.forEach(element => {
                        if (element.template_type === 'agreement') {
                            agreements.push(element);
                        }
                    });
                }
                
                return [...new Set(agreements)]
            },

            defaultAgreement() {
                if(this.globalContext.templatesContext !== null && this.globalContext.templatesContext !== undefined){
                    let templates = this.globalContext.templatesContext
                    let duration = this.duration 
                    
                    let defaultObj = templates.filter(function(template){
                        return template.property.duration == duration;
                    });
                    return defaultObj[0].agreement.default;
                }
                return {}
            },

            defaultTemplateTypeAll() {
                let tmpList = this.globalContext.listsContext.agreementTemplates[3].defined.concat(this.globalContext.listsContext.agreementTemplates[3].starter)
                tmpList = tmpList.concat(this.globalContext.listsContext.proposalTemplates[5].starter)
                tmpList = tmpList.concat(this.globalContext.listsContext.agreementTemplates[5].defined)
                tmpList = tmpList.concat(this.globalContext.listsContext.proposalTemplates[3].defined)
                // Commented out until we get two default template types (one for 3 year and one for 5 year in the DB for starters)
                // When ready to uncomment this, then remove line 330
                // tmpList = tmpList.concat(this.globalContext.listsContext.proposalTemplates[3].starter)
                // tmpList = tmpList.concat(this.globalContext.listsContext.proposalTemplates[5].starter)
                
               
                tmpList = tmpList.concat(this.globalContext.listsContext.proposalTemplates[5].defined)
                
                
                return tmpList;
            },

            companyNameErrors() {
                const errors = [];
                return errors;
            },

            voyaAccountsErrors() {
                const errors = [];
                return errors;
            },

        },

        methods: {

            ...mapActions([
                'updateTpaTemplateDefaults',
                'uploadTemplate',
                'downloadTemplate',
                'deleteTemplate',
                'getPlanOpportunityDefaultSelection',
                'updatePlanOpportunityDefaultSelection',
                'raiseMessage']),


            loadTemplateList(template, filterType, filterByVal) {

                if (this.globalContext.listsContext !== null) {
                    var tabs = document.getElementsByClassName('template-tab');
                    tabs.forEach(element => {
                        element.classList.remove('active');
                    });
                    this.$refs[template].classList.add('active');
                    this.current_tab = template;
                    
                    console.log(tabs)
                    console.log(template)
                    
                    let templateList = this.defaultTemplateTypeAll
                
                    if (template === 'company') {
                        let filteredData =  templateList.filter(value => {
                            console.log('VALUE')
                            console.log(value)
                            if (filterByVal) {
                                return value.entity_id !== null && ((filterType === 'type' && value.template_type === filterByVal.template_type) || (filterType === 'duration' && value.duration === parseInt(filterByVal)));
                            } else {
                                return value.entity_id !== null;
                            }
                        });
                        console.log('FILTERED DATA')
                        console.log(filteredData)
                        console.log('FILTERED BY VALUE')
                        console.log(filterByVal)
                        this.templateListData = filteredData;
                        
                    } else if (template === 'starter') {
                        let filteredData =  templateList.filter(value => {
                            if (filterByVal) {
                                return value.entity_id === null && ((filterType === 'type' && value.template_type === filterByVal.template_type) || (filterType === 'duration' && value.duration === parseInt(filterByVal)));
                            } else {
                                return value.entity_id === null;
                            }
                        });
                        console.log('FILTERED DATA')
                        console.log(filteredData)
                        console.log('FILTERED BY VALUE')
                        console.log(filterByVal)
                        this.templateListData = filteredData;
                    }
                
                }
                return true;
            },

            /**
            preview(event) {
                console.log(event);
                window.open('https://docx-to-pdx-s3-test-bucket.s3-us-west-2.amazonaws.com/results1/user1/2020/10/16/0b189b78-4c6d-4c51-a3f0-a2c5e453192d/0eb26485-f8a0-4c1f-975d-319a4cb1a156.result.pdf');
            },
            **/

            download(row) {
                this.downloadTemplate(row);
            },

            async handleupdatePlanOpportunityDefaultSelection(){
                const request = {
                    plan_opportunity_default_selection: this.planOpportunityDefaultSelection
                }
                await this.updatePlanOpportunityDefaultSelection(request)
                this.raiseMessage('Successfully saved your plan opportunity duration defaults!')
            },
            
            deleteTmp(row, index) {
                let defaultPropTemplateId = this.defaultProposal.template_id;
                let defaultAgreemTemplateId = this.defaultAgreement.template_id;
                
                this.deleteDialog[index] = false
                
                if (defaultPropTemplateId !== row.template_id && defaultAgreemTemplateId !== row.template_id && row.entity_id !== null) {
                    this.deleteTemplate(row);
                    this.loadTemplateList('company')
                } else {
                    this.raiseMessage('A default or starter template cannot be deleted.');
                }
            },

            updateDefault(event) {
                let tpa_id = getTPAID();
                let objToUpdate = {
                    "entity_type": "tpa", 
                    "entity_id": tpa_id,
                    "duration":this.duration,
                    "template_id": event.template_id,
                    "template_type": event.template_type
                }
                this.updateTpaTemplateDefaults(objToUpdate);
            },

            async submitUpload() {
                this.$refs.form.validate();
                this.$refs.form.inputs.forEach(element => {
                    if (!element.valid) {
                        this.valid = false;
                    }
                });

                if (this.valid) {
                    let tpa_id = getTPAID();
                    let formObj = {
                        entity_type: 'tpa',
                        entity_id: tpa_id,
                        template_name: this.template_name,
                        template_type: this.template_type,
                        duration: this.durationUpload,
                        uploaded_file: await toBase64(this.file)
                    }
                    this.uploadTemplate(formObj);
                    this.template_name = null,
                    this.template_type = null,
                    this.durationUpload = 5,
                    this.file =null,
                    this.closeDialog();

                }
            },

            closeDialog() {
                this.dialog = false;
                this.$refs.form.reset();
                this.$refs.form.resetValidation()
            }

        },

        watch: {

            defaultProposal() {
                this.loadTemplateList(this.current_tab);
            },

            defaultTemplateTypeAll: {
                deep: true,
                handler() {
                    this.loadTemplateList('company');
                }
            }
        }

    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    Array.prototype.indexOfField = function (propertyName, value) {
    for (var i = 0; i < this.length; i++)
        if (this[i][propertyName] === value)
            return i;
    return -1;
}

</script>

<style scoped>

    h1 {
        max-width: 900px;
        margin: 15px auto;
    }

    .custom-card {
        max-width:1200px;
        margin: auto;
        border-radius:50px;
        box-shadow: 0px 0px 5px -2px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .custom-row {
        margin-bottom: 15px;
        padding-left: 5px;
        padding-right: 5px;
    }
    
    .custom-width{
      width: 100%;
    }

    .custom-card .custom-row:first-of-type {
        padding-top: 15px;
    }

    .custom-group:nth-of-type(3) {
        text-align: center;
    }
    
    .label.col {
        align-self: center;
    }

    .custom-row:nth-of-type(1) .custom-group .label {
        text-align: right;
        align-self: center;
        padding-right: 10px;
    }
    
    .theme--light.v-sheet--outlined {
        border: thin solid rgb(0,0,0,30%);
    }

    .template-tabs-wrapper {
        display: flex;
    }

    .template-tab {
        border-top: 1px solid grey;
        border-right: 1px solid grey;
        border-left: 1px solid grey;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        padding: 5px;
        padding-left: 15px;
        padding-right: 15px;
        cursor: pointer;
        top: 1px;
        position: relative;
    }

    .template-tab.active {
        background-color: #242c6b;
        color: white;
        top: 1px;
        position: relative;
    }

    .template-content-wrapper {
        width: 100%;
        border: 1px solid grey;
        min-height: 200px;
    }

    .template-content-header {
        border-bottom: 1px solid grey;
        height: 40px;
        background-color: #242c6b;
    }

    .template-content-row,   
    .template-content-header {
        display: flex;
        width: 100%;
    }

    /* .template-content-row:not(:last-of-type) { */
    .template-content-row {
        border-bottom: 1px solid lightgray !important;
    }

    .template-content-row:nth-child(odd) {
        background-color: whitesmoke;
    }

    .template-content-row:hover {
        background-color: #eae7e7;
    }
    
    .header-col {
        align-self: center;
        padding: 5px;
        color: white;
    }

    .row-content-col {
        align-self: center;
        padding: 5px;
    }

    .row-content-col .btn-name {
        padding-right: 10px;
    }

    .header-col:nth-of-type(1),
    .row-content-col:nth-of-type(1) {
        min-width: 31%;
    }
    
    .header-col:nth-of-type(n+2),
    .row-content-col:nth-of-type(n+2) {
        min-width: 12%;
    }

    .header-col:nth-of-type(n+4),
    .row-content-col:nth-of-type(n+4) {
        min-width: 15%;
    }

    .row-content-col:nth-of-type(n+4) button {
        margin-left: 0px !important;
        width: 100%;
    }

    .custom-toolbar,
    .custom-toolbar >>> .v-toolbar__content {
        height: 50px !important;
    }

    .custom-toolbar span {
        flex-grow: 1;
    }

    .custom-toolbar.content-title, 
    .custom-toolbar.content-title >>> .v-toolbar__content {
        height: 35px !important;
        line-height: 27px;
        display: block;
        text-align: center;
        margin-bottom: 15px;
    }
    
    
    @media only screen and (min-width: 1000px) {
      
        .header-col:nth-of-type(1),
        .row-content-col:nth-of-type(1) {
            min-width: 41%;
        }
        
        .header-col:nth-of-type(n+2),
        .row-content-col:nth-of-type(n+2) {
            min-width: 12%;
        }
    
        .header-col:nth-of-type(n+4),
        .row-content-col:nth-of-type(n+4) {
            min-width: 11%;
        }
      
    }

</style>